import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { setErrors } from '../common/errorsSlice'
import { AppThunk } from '../store'
import { getNoticeList, postNotice } from '../../apis/notice'
import {
  Notice,
  ArticleIndex,
  PostArticleParams,
} from '../../types/notice'

interface NoticeListState {
  notices: Notice[]
  isLoading: boolean
  member_created_at: string
}

const initialState: NoticeListState = {
  notices: [],
  isLoading: true,
  member_created_at: '',
}

const noticeListSlice = createSlice({
  name: 'noticeList',
  initialState,
  reducers: {
    requestStart: (state) => {
      state.isLoading = true
      return state
    },
    getNoticeSuccess: (state, action: PayloadAction<ArticleIndex>) => {
      state.notices = action.payload.notices
      state.member_created_at = action.payload.member_created_at
      state.isLoading = false
      return state
    },
    requestFailure: (state) => {
      state.isLoading = false
      return state
    },
  },
})

export const {
  requestStart,
  getNoticeSuccess,
  requestFailure,
} = noticeListSlice.actions

export const noticeListReducer = noticeListSlice.reducer

export const fetchNoticeList = (): AppThunk => async (dispatch) => {
  dispatch(requestStart())
  getNoticeList()
    .then((result) => {
      dispatch(getNoticeSuccess(result))
    })
    .catch((error) => {
      dispatch(requestFailure())
      dispatch(setErrors(error))
    })
}

export const updateNoticeList = (
  params: PostArticleParams,
): AppThunk => async (dispatch) => {
  postNotice(params)
    .then(() => {
      dispatch(fetchNoticeList())
    })
    .catch((error) => {
      dispatch(requestFailure())
      dispatch(setErrors(error))
    })
}
